import {Component, OnInit} from '@angular/core';
import {ConfirmationService, MessageService, TreeNode} from 'primeng/api';
import {TranslocoService} from '@ngneat/transloco';
import {CommonMessagesService} from '../../../services/common-messages.service';
import {UsersService} from '../../../services/users.service';
import {UserFilters} from '../../../model/filters/user-filters';
import {User, UserProfile} from '../../../model/user';
import {AuthGuard} from "../../../common/auth-guard.service";
import {HierarchyService} from "../../../services/hierarchy.service";
import {ProfilesService} from "../../../services/profiles.service";

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {

  public users: User[];
  public totalUsers: number;
  public loadingUsers: boolean;

  public rows: number = 10;
  public first: number = 0;

  public filtersVisible: boolean;
  public currentFilters: UserFilters;

  public hierarchy: TreeNode[];
  public organizations: any[];

  public profiles: UserProfile[];
  public userTypeOptions: { label: string, value: string }[] = [];


  constructor(private usersService: UsersService,
              private messageService: MessageService,
              private i18n: TranslocoService,
              private guard: AuthGuard,
              private confirmationService: ConfirmationService,
              private commonMessagesService: CommonMessagesService,
              private hierarchyService: HierarchyService,
              private profilesService: ProfilesService) {
    this.currentFilters = new UserFilters();
  }

  ngOnInit(): void {
    this.users = new Array(this.rows);
    this.loadFilters();
  }

  loadFilters(): void {
    this.buildTreeNode();
    this.buildUserTypeOptions();
    this.profilesService.getProfilesSummary().toPromise().then(response => {
      this.profiles = response.profiles;
    });
  }

  buildTreeNode(): void {
    this.hierarchyService.getHierarchyDropdown().subscribe(response => {
      this.hierarchy = this.hierarchyService.getHierarchyTreeNodeFilter(response.hierarchyDto)[1];
    });
  }

  private buildUserTypeOptions(): void {
    this.i18n.selectTranslation().subscribe(() => {
      this.userTypeOptions = [
        {label: this.i18n.translate('common.all'), value: 'ALL'},
        {label: this.i18n.translate('attribute.systemUsers'), value: 'SYSTEM_USERS'},
        {label: this.i18n.translate('attribute.eCommerceUsers'), value: 'E_COMMERCE_USERS'},
      ];
    });
  }

  onPageChange(event): void {
    this.loadUsers(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new UserFilters();
    this.organizations = [];
  }

  applyFilters(): void {
    this.first = 0;
    this.currentFilters.organizationUuids = [];
    if (this.organizations != null && this.organizations.length > 0) {
      this.organizations.forEach(organization => {
        this.currentFilters.organizationUuids.push(organization.data);
      });
    }
    this.loadUsers(this.first / this.rows, this.rows);
  }

  confirmAndDelete(user: User): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteUser(user.userUuid);
    });
  }

  deleteUser(userUuid: string): void {
    this.usersService.deleteUser(userUuid).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadUsers(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  trimFieldsForm(filters: UserFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  private loadUsers(offset?: number, limit?: number): void {
    this.loadingUsers = true;
    this.users = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.usersService.getUsers(offset, limit, this.currentFilters)
      .subscribe(response => {
        this.users = response.data.content;
        this.totalUsers = response.data.totalElements;
        this.loadingUsers = false;
      });
  }

}
